import React from 'react';
import { View } from 'react-native';
import StepIndicatorBar from './StepIndicatorBar';
import LinkTextButton from '../Buttons/LinkTextButton';
import { LocStr } from '../../../utils/Utils';
import { edit_order } from '../../../utils/DictionaryManagementUtils';

//= ========================================================================

const StepIndicator = ({
  language, onGotoEdit, titles, onStepPressed, myScreen, isHollow, hideStepIndicator,
}) => (
  <View>
    {!hideStepIndicator && (
    <View style={{
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingTop: 30,
    }}
    >
      <StepIndicatorBar
        titles={titles}
        stepIndex={myScreen.step_index}
        isHollow={isHollow}
        onCirclePressed={(i) => {
          onStepPressed(i, myScreen);
        }}
      />
      {onGotoEdit && <LinkTextButton onPress={onGotoEdit}>{LocStr(edit_order, language)}</LinkTextButton>}
    </View>
    )}
  </View>
);

export default StepIndicator;
